import { memo } from 'react'
import isEqual from 'react-fast-compare'
import { useTranslation } from 'react-i18next'

import styles from '../../validationSubmissionsTable/ValidationSubmissionsTable.module.scss'
import { ValidationSubmissionFiltersProps } from '../../validationSubmissionsTable/ValidationSubmissionsTable.types'
import {
  usePartnerNameFilter,
  useProgramNameFilter,
  useValidationSubmissionSearch
} from '../../validationSubmissionsTable/hooks'

import { Chip, FilterList, SearchFilterList, SearchInput } from '@percent/lemonade'

// The All tab's filters, less country and status: every held submission is pending, and the holds
// endpoint does not filter by country.
export const HeldValidationSubmissionsFilters = memo(
  ({ queryParams, setQueryParams }: ValidationSubmissionFiltersProps) => {
    const { t } = useTranslation()

    const { searchValue, handleClearValue, handleKeyChange, handleKeyPress, searchInputStatusMessage } =
      useValidationSubmissionSearch({ queryParams, setQueryParams })
    const { selectedPartners, onPartnerChange, partnerNameOptions, isPartnerNameFilterLoading, partnerSearch } =
      usePartnerNameFilter({ queryParams, setQueryParams })
    const { programNameOptions, onProgramChange, selectedPrograms, isSelectedProgramsFilterDisabled } =
      useProgramNameFilter({ queryParams, setQueryParams })

    const partnerNameChipValue = partnerNameOptions?.find(option => option.value === queryParams.partnerId)?.label

    return (
      <div className={styles.filtersAndChipsContainer}>
        <div className={styles.filtersContainer}>
          <SearchInput
            value={searchValue ?? ''}
            handleClearValue={handleClearValue}
            onKeyDown={handleKeyPress}
            onChange={handleKeyChange}
            placeholder={t('table.searchByAgentsEmailOrSpecificCheck')}
            statusMessage={searchInputStatusMessage}
            status={searchInputStatusMessage ? 'danger' : 'default'}
          />
          <div className={styles.filtersWrapper}>
            <SearchFilterList
              options={partnerNameOptions}
              isLoading={isPartnerNameFilterLoading}
              selectedValues={selectedPartners}
              onChange={onPartnerChange}
              searchValue={partnerSearch.partnerNameSearch}
              onSearchChange={partnerSearch.onPartnerSearchChange}
              handleClearValue={partnerSearch.onClearPartnerSearchValue}
              onKeyDown={partnerSearch.handleKeyPress}
              onButtonClick={partnerSearch.onPartnersSearchButtonClick}
              testId="partner-name-search-filter"
              buttonText={t('typography.search')}
              placeholder={t('typography.search')}
              label={t('typography.partner')}
              placement="bottom"
            />
            <FilterList
              label={t('typography.programName')}
              options={programNameOptions}
              selectedValues={selectedPrograms}
              onChange={onProgramChange}
              isDisabled={isSelectedProgramsFilterDisabled}
              tooltipContent={t('typography.programNameTooltip')}
              testId="program-name-filter"
            />
          </div>
        </div>
        <div className={styles.filtersChipContainer}>
          {queryParams.partnerId && (
            <Chip
              label={t('typography.partner')}
              value={partnerNameChipValue}
              onClick={() => onPartnerChange([])}
              testId="partner-filter-chip"
            />
          )}
        </div>
      </div>
    )
  },
  isEqual
)
